import * as React from "react";
import { useContext, useEffect } from "react";
import { styled } from "@mui/material";
import { TermsOfService } from "../../../containers/termsOfService";
import { commonBoxShadowStyle } from "fe-common/ui/boxShadow";
import {
  MobileView,
  SingleViewPerLayoutBreakPoint,
} from "../../../util/aKaunGeneralUtil";
import { useDiagnosticNavigation } from "../useDiagnosticNavigation";
import { SearchQueriesContext } from "../../../context/searchQuery";
import { RosebudDesktopBottomNavigationHeight } from "../rosebud/desktopBottomNavigation";

//region [[ Styles ]]

const WizardTermOfServiceView = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  height: "100%",
  [theme.breakpoints.up(SingleViewPerLayoutBreakPoint)]: {
    paddingBottom: `${RosebudDesktopBottomNavigationHeight}px`,
  },
  [theme.breakpoints.down(MobileView)]: {
    height: "auto",
    margin: "24px",
  },
}));

const TermOfServiceBox = styled("div")({
  background: "white",
  borderRadius: "14px",
  ...commonBoxShadowStyle,
});

//endregion [[ Styles ]]

//region [[ Props ]]

export interface WizardTermOfServiceProps {}

//endregion [[ Props ]]

//region [[ Functions ]]
//endregion [[ Functions ]]

export const WizardTermOfService = ({ ...props }: WizardTermOfServiceProps) => {
  const { agreeOnTerms } = useContext(SearchQueriesContext);

  const { setNextRouteNavigationDisabled } = useDiagnosticNavigation();

  useEffect(() => {
    if (agreeOnTerms) {
      setNextRouteNavigationDisabled(false);
    } else {
      setNextRouteNavigationDisabled(true);
    }
    return () => {
      setNextRouteNavigationDisabled(false);
    };
  }, [agreeOnTerms, setNextRouteNavigationDisabled]);

  return (
    <WizardTermOfServiceView>
      <TermOfServiceBox>
        <TermsOfService />
      </TermOfServiceBox>
    </WizardTermOfServiceView>
  );
};
